/**
 * Page-muse-sdk template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Global from './lib/global';
import Logger from './lib/logger';
import KeenSlider from 'keen-slider'

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = 'Page-Muse-SDK';

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

// Bootstrap global functionality
Global();

/**
 * Init
 **/
const init = () => {
	Logger.info(`${NAME} > init...`);
    collapseable();
    globalResearchCarousel();
}

const collapseable = () => {
    Logger.info(`${NAME} > initFaqModule...`);

    const accordionTitles = document.querySelectorAll(".global-accordion-wrapper-item__title");

    accordionTitles.forEach((accordionTitle) => {
        accordionTitle.addEventListener("click", () => {
            if (accordionTitle.classList.contains("is-open")) {
                accordionTitle.classList.remove("is-open");
            } else {
                const accordionTitlesWithIsOpen = document.querySelectorAll(".is-open");
                accordionTitlesWithIsOpen.forEach((accordionTitleWithIsOpen) => {
                    accordionTitleWithIsOpen.classList.remove("is-open");
                });
                accordionTitle.classList.add("is-open");
            }
        });
    });

}

const globalResearchCarousel = () => {

  function navigation(slider) {
    const arrowLeft = document.querySelector('.global-research-carousel-container .circle-arrow-btn[data-dir="left"');
    const arrowRight = document.querySelector('.global-research-carousel-container .circle-arrow-btn[data-dir="right"');
    
    slider.on("created", () => {
      arrowLeft.addEventListener("click", slider.prev);
      arrowRight.addEventListener("click", slider.next);
    });

    slider.on("destroyed", () => {
      arrowLeft.removeEventListener("click", slider.prev);
      arrowRight.removeEventListener("click", slider.next);
    });
  }

  if (document.getElementById("research-slider")) {
    new KeenSlider(
      "#research-slider",
      {
        loop: true,
        slides: {
            perView: 3,
            spacing: 15,
        },
        breakpoints: {
          "(min-width: 40px)": {
            slides: { perView: 1, spacing: 15},
          },
          "(min-width: 720px)": {
            slides: { perView: 2, spacing: 15 },
          },
          "(min-width: 960px)": {
            slides: { perView: 3, spacing: 15 },
          },
        },
      },
      [navigation]
    );
  }
}


init();

// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.log(`${NAME} > loaded`);
